import BackHeader from '@/layout/components/BackHeader'
import { useLocation, useNavigate } from 'react-router-dom'
import OrderHeroPanel from './components/OrderHeroPanel/OrderHeroPanel'
import './OrderOverview.style.less'
import { Tabs } from 'antd'
import TimeAndAction from './components/TimeAndAction/TimeAndAction'
import ProductionStatus from './components/ProductionStatus/ProductionStatus'
import { useQuery } from 'react-query'
import { getUrlParams } from '@/utils/common'
import { getOrderDetail } from '../Order.transform'
import { useEffect, useState } from 'react'
import LoadingComponent from '@/components/LoadingComponent/LoadingComponent'
import ViewOrder from '../ViewOrder/ViewOrder'
import { useAtom } from 'jotai'
import { currentSelectedCollaborator } from '@/jotai/order.jotai'
import NotFound from '@/components/NotFound/NotFound'
import { getCompanySetting } from '@/screens/SystemConfigure/UserManagment/UserManagment.transform'
import { COMPANY_SETTING_PRODUCTION_STATUS } from '@/constant/user'
import { get } from 'lodash'
import { PBF_QUERY_KEY } from '@/constant/pbf'
import { queryClient } from '@/config/react-query'

interface Props {
  hideProperties?: any
  hideActions?: any
}

function OrderDetail(props: Props) {
  const { hideProperties, hideActions } = props
  const navigate = useNavigate()
  const [activetab, setactivetab] = useState('')

  const [orderId, setOrderId] = useState(getUrlParams('orderKey'))

  const [_, setCollaborator] = useAtom(currentSelectedCollaborator)

  const { data, isLoading, error } = useQuery('ORDER_DETAIL', async () => {
    const response = await getOrderDetail(orderId)
    setCollaborator(response?.collaborator)
    return response
  })

  const { data: productionStatusSetting } = useQuery(
    [PBF_QUERY_KEY.GET_PRODUCTION_STATUS_SETTING],
    async () => {
      return await getCompanySetting('', COMPANY_SETTING_PRODUCTION_STATUS)
    }
  )

  const hasProductionStatus = get(
    productionStatusSetting,
    'value.status',
    false
  )

  const orderKeyParam = getUrlParams('orderKey')

  useEffect(() => {
    setOrderId(orderKeyParam)
  }, [orderKeyParam])

  const TabItems = [
    {
      label: 'Order Details',
      key: '1',
      children: (
        <ViewOrder hideProperties={hideProperties} hideActions={hideActions} />
      ),
    },
    {
      label: 'Time & Action',
      key: '2',
      children: (
        <TimeAndAction
          orderDetail={data?.order}
          collaborator={data?.collaborator}
        />
      ),
    },
    {
      label: 'Production Status',
      key: '3',
      hidden: !hasProductionStatus,
      children: (
        <ProductionStatus
          permission={{
            canRead: data?.order?.can_read,
            canWrite: data?.order?.can_write,
          }}
          data={data?.order?.production_status}
          orderDetail={{
            orderQuantity: data?.order?.order_quantity,
            toBeDeliveredDate: data?.order?.to_be_delivered_date,
          }}
        />
      ),
    },
  ].filter((item) => !item.hidden)

  useEffect(() => {
    setactivetab(getUrlParams('activeTab'))
  }, [])

  const onTabChange = (key: string) => {
    const orderId = getUrlParams('orderKey')
    if (key == '2') {
      navigate(`?orderKey=${orderId}&activeTab=${key}&panelType=timeline`, {
        replace: true,
      })
    } else {
      navigate(`?orderKey=${orderId}&activeTab=${key}`, {
        replace: true,
      })
    }
    setactivetab(key)
  }

  const location = useLocation()
  const onGoBack = () => {
    if (location.key !== 'default') {
      navigate(-1)
    } else {
      navigate('/pbf')
    }
  }

  if (isLoading) return <LoadingComponent />

  if (get(error, 'response.status') === 404) {
    return (
      <>
        <BackHeader onClick={() => navigate('/pbf')} title="Back to Orders" />
        <NotFound redirect="/pbf" />
      </>
    )
  }
  return (
    <>
      <BackHeader onClick={() => onGoBack()} title="Back to Orders" />
      <div className="new-order-detail-container">
        <OrderHeroPanel
          data={data?.order}
          collaborators={data?.collaborator}
          onCollaboratorsUpdate={() =>
            queryClient.refetchQueries('ORDER_DETAIL')
          }
        />
        <Tabs onChange={onTabChange} activeKey={activetab} items={TabItems} />
      </div>
    </>
  )
}

export default OrderDetail
